/** @jsxImportSource theme-ui @jsxRuntime classic */
import React from 'react';

import { Button } from '..';

export interface SubmitButtonProps {
  text: string;
  disabled: boolean;
}

export const SubmitButton = ({
  text,
  disabled,
}: SubmitButtonProps): React.JSX.Element => (
  <Button
    aria-label={text}
    data-element="SubmitButton"
    data-testid="confirm-order-button"
    disabled={disabled}
    role="button"
    type="submit"
    variant="submit"
  >
    {text}
  </Button>
);

export default SubmitButton;
